import styled from 'styled-components';

const Description = styled.div`
  margin-right: auto;
  margin-left: auto;
  max-width: 1200px;
  width: 100%;
  h3 {
    color: #fff;
    text-transform: uppercase;
    margin: 0;
    font-size: 26px;
    @media (max-width: 767px) {
      font-size: 15px;
    }
  }
  h2 {
    color: #113d56;
    text-transform: uppercase;
    font-weight: 400;
    font-size: 30px;
    margin-top: 8px;
  }
  p {
    margin: 0;
    font-size: 16px;
    color: #fff;
  }
  @media (max-width: 767px) {
    h3 {
      font-size: 15px;
    }
    h2 {
      font-size: 20px;
    }
  }
`;
const Separator = styled.div`
  margin: 15px 0 7.5px;
  display: flex;
  width: 50px;
  height: 6px;
  background: #272742;
`;
const Profit = styled.div`
  display: grid;
  grid-gap: 20px;
  align-items: center;
  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
  > div {
    display: grid;
    align-items: center;
    padding: 7.5px 0;
  }
  Button {
    color: #272742;
    background-color: #fff;
    height: 44.5px;
    font-weight: 700;
    transition: all 0.3s ease-in-out;
    &:hover {
      background-color: #272742;
      color: #fff;
    }
  }
`;

const CustomerPay = styled.div`
  border-bottom: 1px solid #000;
  display: grid;
  align-items: center;
  padding: 7.5px 0;
  p {
    color: #113d56;
    font-weight: 700;
    margin: 0;
  }
  h5 {
    color: #fff;
    font-weight: 700;
    font-size: 30px;
    margin: 0;
    sup {
      font-size: 75%;
      line-height: 0;
      position: relative;
      vertical-align: baseline;
      top: -7.5px;
    }
  }
`;
const YouPay = styled.div`
  border-bottom: 1px solid #000;
  display: grid;
  align-items: center;
  padding: 7.5px 0;
  p {
    color: #113d56;
    font-weight: 700;
    margin: 0;
  }
  h5 {
    color: #fff;
    font-weight: 700;
    font-size: 30px;
    margin: 0;
    sup {
      font-size: 75%;
      line-height: 0;
      position: relative;
      vertical-align: baseline;
      top: -7.5px;
    }
  }
`;
const YourProfit = styled.div`
  display: flex !important;
  margin: 0;
  padding: 0;
  align-items: center;
  font-size: 22px;
  p {
    color: #113d56;
    font-weight: 700;
    margin: 0;
    font-size: 23px;
  }
  h5 {
    color: #fff;
    font-weight: 700;
    font-size: 45px;
    margin: 0;
    margin-left: 14px;
    sup {
      font-size: 75%;
      line-height: 0;
      position: relative;
      vertical-align: baseline;
      top: -7.5px;
    }
  }
`;

export { Description, Separator, Profit, CustomerPay, YouPay, YourProfit };
